<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav :title="$t('添加流动性.添加流动性')" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
				<div class="flex items-center bg-white/10 rounded-20 p-30">
					<div>
						<img class="w-88 h-88" src="@/assets/images/pages/add-lp/ts.png" alt="" />
					</div>
					<div class="ml-20">
						<div>
							<span class="text-28 text-white">{{$t('添加流动性.重要提示')}}</span>
						</div>
						<div class="mt-10">
							<span class="text-24 text-#999">{{$t('添加流动性.每个钱包地址仅可添加一次LP，20天锁定期内无法撤出，请谨慎操作')}}</span>
						</div>
					</div>
				</div>
				<div class="mt-20 bg-white/10 rounded-20 p-30">
					<div class="">
						<span class="text-36 text-white">{{$t('添加流动性.添加LP组合')}}</span>
					</div>

                    <div class="mt-30 flex items-center justify-between">
                        <span class="text-24 text-#999">ROON{{$t('添加流动性.数量')}}</span>
                        <span class="text-24 text-white">{{$t('添加流动性.余额')}} {{roon_blanace}}</span>
                    </div>
                    <div class="mt-20 px-20 flex items-center justify-between h-130 rounded-20" style="background-color: #0F0F10;">
                        <input type="text" class="w-350 text-32 font-bold text-white" v-model="need_roon" readonly :placeholder="$t('添加流动性.请输入ROON数量')" />
                        <img class="w-68 h-68" src="@/assets/images/pages/add-lp/icon_roon.png" alt="" />
                    </div>


					<div class="mt-20 flex items-center justify-center">
						<img class="w-160 h-160" src="@/assets/images/pages/add-lp/zh.png" alt="" />
					</div>


                    <div class="mt-30 flex items-center justify-between">
                        <span class="text-24 text-#999">USDR{{$t('添加流动性.数量')}}</span>
                        <span class="text-24 text-white">{{$t('添加流动性.余额')}} {{usdr_blanace}}</span>
                    </div>
                    <div class="mt-20 px-20 flex items-center justify-between h-130 rounded-20" style="background-color: #0F0F10;">
                        <input type="text" class="w-350 text-32 font-bold text-white" v-model="need_usdr" readonly :placeholder="$t('添加流动性.请输入USDR数量')" />
                        <img class="w-68 h-68" src="@/assets/images/common/usdr.png" alt="" />
                        <!--						<div class="ml-30 px-30 flex-shrink-0 bg-white/10 rounded-20 flex items-center justify-center h-70">-->
                        <!--							<span class="text-30 text-white font-bold">{{$t('添加流动性.最大')}}</span>-->
                        <!--						</div>-->
                    </div>

					<div class="mt-20">
						<span class="text-24 text-#999">{{$t('添加流动性.LP组成比例为')}} 1:{{roon_usdr}} （R00N:USDR）</span>
					</div>
					<div class="mt-30 rounded-full bg-primary h-100 flex items-center justify-center" @click="showAmountPopup = true">
						<span class="text-32 text-white font-bold">{{$t('添加流动性.确认添加LP')}}</span>
					</div>
				</div>
				<div class="mt-20 bg-white/10 rounded-20 p-30" style="background-color: #19191A;">
					<div class="">
						<span class="text-white text-36">{{$t("添加流动性.挖矿规则")}}</span>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 p-30">
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("添加流动性.锁走周期20天，期间无法撤出")}}</span>
						</div>
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("添加流动性.每天固定收益1个ROON代币")}}</span>
						</div>
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("添加流动性.保障本金安全，不受市场价格波动影响")}}</span>
						</div>
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("添加流动性.每个钱包地址仅可添加一次LP")}}</span>
						</div>
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("添加流动性.所有数据链上透明可查")}}</span>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<!-- <menu-bar activeMenu="node"></menu-bar> -->
		</template>
		<template v-slot:popup>
			<van-popup v-model="showAmountPopup" position="center" round>
				<div class="w-690">
					<div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30">
						<div class="flex items-center justify-center mt-20">
							<span class="text-36 text-white">{{$t("添加流动性.确认添加LP")}}</span>
						</div>
						<div class="flex items-center justify-center mt-20">
							<span class="text-26 text-#999">{{$t("添加流动性.您即将添加")}}</span>
						</div>
						<div class="flex items-center justify-center">
							<span class="text-26 text-primary">  {{need_roon}} ROON + {{need_usdr}} USDR  </span>
						</div>
						<div class="flex items-center justify-center">
							<span class="text-26 text-#999">{{$t("添加流动性.到流动性池")}}</span>
						</div>
						<div class="rounded-18 bg-#1B1B1B  mt-20 mx-20 p-30">
							<div class="flex items-center justify-between">
								<span class="text-24 text-white">{{$t("添加流动性.锁定期")}}</span>
								<span class="text-24 text-white">20{{$t("添加流动性.天")}}</span>
							</div>
<!--							<div class="mt-30 flex items-center justify-between">-->
<!--								<span class="text-24 text-white">{{$t("添加流动性.预计收益")}}</span>-->
<!--								<span class="text-24 text-primary">20 ROON</span>-->
<!--							</div>-->
						</div>
						<div class="mt-40 flex items-center justify-center">
							<div @click="showAmountPopup = false"
								class="w-270 h-100 bg-white/10 rounded-full flex items-center justify-center mr-10">
								<span class="text-32 text-white">{{$t('弹窗.取消')}}</span>
							</div>
							<div @click="addLp"
								class="w-270 h-100 bg-primary rounded-full flex items-center justify-center ml-10">
								<span class="text-32 text-white">{{$t('闪兑.确认')}}</span>
							</div>
						</div>
					</div>
				</div>

			</van-popup>
			<!-- 全局不可取消 Loading 遮罩 -->
			<van-overlay :show="paying" :z-index="9999" class-name="flex items-center justify-center">
				<div class="flex flex-col items-center justify-center h-full" @click.stop>
					<van-loading type="spinner" color="#5ACC3C" size="40px" vertical>
						<span class="mt-20 text-white text-28">{{$t('添加流动性.交易处理中')}}...</span>
					</van-loading>
				</div>
			</van-overlay>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBar from '@/components/menu-bar/menu-bar.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import LiquidityManagementAbi from "@/abi/LiquidityManagementAbi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBar,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				typeList: [],
				queryInfo: {
					page: 1,
					type: 1
				},
				min_number: 0,
				node_allocate: 0,
				node_release: 0,
				node_low_pool: 1995,
				node_day: 0,
				node_number: 0,
				node_has: 0,
				node_price: 0,
				node_progress: 0,
				node_surplus_number: 0,
				last_pledge_id: 0,
				last_pledge_time: "",
				all_surplus_roon: "",
				roon_number: "100000",
				node_name: "",
				rgt_swap: "",
				mining_contract: "",
				last_pledge_usdt: "",
				last_pledge_name: "",
				usdr_blanace: "",
				roon_blanace: "",
				roon_usdr: "",
				need_roon: "",
				need_usdr: "",
                totalUsdr: 200,
				address: "",
				total_address: "",
				show_address: "",
				order_id: "",
				users_id: "",
				contract_address: "0xf3708a77ea0282de751244194c304554d5a5d7ed",
				usdt_address: "0x55d398326f99059fF775485246999027B3197955",
				usdr_address: "0xbC75b416D9b4045BBF31d3F9DA7eD727aFCa2f79",
				lp_address: "0xFC5Ee21f8afe9Ce7Ed8be9839C62c0d733c8CDB2",
				wroon_address: "0xB142a57E25eF20De7A881ea22c10b11e47c0B1a0",
                FACTORY_ADDRESS:"0xf4516EFf9b8F046E86B64FD6956dce0928296856",
                ROUTER_ADDRESS:"0xa54d92bEd6455E43a09f6315fD050edFA9997306",
				web3Provider: null,
				web3: null,
				list: [],
				amountList: [],
				showAmountPopup: false,
				// 支付进行中的不可关闭 loading 遮罩
				paying: false,
				canGo: true,
				form: {
					type: 1,
					amount: 0,
					dd_roon: 0,
					amount_id: 0
				},
				// 是否购买
				isBuy: true,
				numberList: [{
						id: 1,
						num: 100
					},
					{
						id: 2,
						num: 500
					},
					{
						id: 3,
						num: 1000
					},
					{
						id: 4,
						num: 2000
					},
					{
						id: 5,
						num: 5000
					},

				]
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
			activeType() {
				let item = {};
				item = this.typeList.find(item => item.id == this.queryInfo.type) || {};
				return item;
			},
			activeAmount() {
				let item = {};
				item = this.amountList.find(item => item.id == this.form.amount_id) || {};
				return item;
			}
		},
		created() {
            let vm = this
            getShowAddress()
            vm.fetchNativeAndUsdrBalance()
            vm.fetchNativePriceInUsdt()
		},
		methods: {
            async addLp(){
                const vm = this;
                // 120秒缓存限制
                const lastTime = localStorage.getItem('last_add_lp_time');
                if (lastTime && new Date().getTime() - lastTime < 120 * 1000) {
                     vm.$message && vm.$message.error("一天只能参与一次");
                     return;
                }

                try {
                    // 基本校验
                    if (!vm.need_usdr || !vm.need_roon) {
                        vm.$message && vm.$message.error('缺少配对数量 need_usdr / need_roon');
                        return;
                    }

                    // 先调用后端接口，成功后再继续链上交易
                    try {
                        const resp = await ajaxData("/lp/can", {  });
                        if (resp.data.can_join != 0){
                            vm.$message.error("一天只能参与一次");
                            return;
                        }
                        console.log("/lp/can resp", resp.data.can_join);
                        // return;
                    } catch (apiErr) {
                        console.error("/lp/can error", apiErr);
                        vm.$message.error(apiErr?.message || vm.$t("吐司.操作失败"));
                        vm.paying = false;
                        return; // 接口异常直接结束，不继续链上操作
                    }

                    vm.paying = true; // 开启遮罩

                    // 初始化 web3
                    if (!vm.web3) {
                        const provider = (typeof window !== 'undefined' && window.ethereum) || Web3.givenProvider;
                        if (!provider) {
                            vm.$message && vm.$message.error('未检测到 Web3 提供者，无法添加流动性');
                            // 失败时需手动关闭，但这里是在 try 中，finally 会处理
                            return;
                        }
                        vm.web3Provider = provider;
                        vm.web3 = new Web3(provider);
                    }

                    // 获取地址（优先使用现有地址，否则尝试从钱包获取）
                    let from = vm.address;
                    if (!from) {
                        try {
                            if (vm.web3 && vm.web3.eth && vm.web3.eth.requestAccounts) {
                                const accounts = await vm.web3.eth.requestAccounts();
                                from = accounts && accounts[0] ? accounts[0] : '';
                                vm.address = from;
                            } else {
                                const accounts = await vm.web3.eth.getAccounts();
                                from = accounts && accounts[0] ? accounts[0] : '';
                                vm.address = from;
                            }
                        } catch (e) {
                            vm.$message && vm.$message.error(`获取钱包地址失败: ${e && e.message ? e.message : e}`);
                            return; // finally 会关闭
                        }
                    }

                    if (!from) {
                        vm.$message && vm.$message.error('地址为空，无法执行授权与添加流动性');
                        return;
                    }

                    // 转换为 Wei（USDR 与主币均为 18 位精度）
                    const tokenAmountWei = vm.web3.utils.toWei(String(vm.need_usdr), 'ether');
                    const nativeAmountWei = vm.web3.utils.toWei(String(vm.need_roon), 'ether');

                    // 1. 先进行 USDR 授权：批准 lp_address 可花费 need_usdr
                    const usdr = new vm.web3.eth.Contract(erc20Abi, vm.usdr_address);
                    // vm.paying = true; // 移到最上面了
                    try {
                        await usdr.methods.approve(vm.lp_address, tokenAmountWei).send({ from });
                    } catch (approveErr) {
                        vm.$message && vm.$message.error(`授权 USDR 失败: ${approveErr && approveErr.message ? approveErr.message : approveErr}`);
                        return;
                    }

                    // 2. 调用 LiquidityManagement 合约的 addLiquidity 方法（payable），支付主币与代币金额
                    const liquidity = new vm.web3.eth.Contract(LiquidityManagementAbi, vm.lp_address);
                    let tx;
                    try {
                        tx = await liquidity.methods.addLiquidity(tokenAmountWei).send({ from, value: nativeAmountWei });
                    } catch (liquidityErr) {
                        vm.$message && vm.$message.error(`添加流动性交易失败: ${liquidityErr && liquidityErr.message ? liquidityErr.message : liquidityErr}`);
                        return;
                    }
                    vm.showAmountPopup = false

                    console.log('添加流动性成功，交易回执：', tx);
                    localStorage.setItem('last_add_lp_time', new Date().getTime());
                    vm.$message && vm.$message.success('添加流动性成功');
                } catch (err) {
                    vm.$message && vm.$message.error(`添加流动性失败: ${err && err.message ? err.message : err}`);
                } finally {
                    this.paying = false;
                }
            },
			// 字符串截断为固定小数位（不四舍五入）
			formatToFixedTrunc(numStr, decimals = 6) {
				try {
					const s = String(numStr ?? '0');
					const [intPart = '0', fracPart = ''] = s.split('.');
					const truncatedFrac = fracPart.slice(0, decimals).padEnd(decimals, '0');
					return `${intPart}.${truncatedFrac}`;
				} catch (_) {
					return `0.${'0'.repeat(decimals)}`;
				}
			},
            // 获取主币对 USDR 的路由价格，并赋值到 roon_usdr；
            // 同时计算总价值 20 USDR 的等值配对数量 need_roon / need_usdr（保留 6 位小数，截断）
            async fetchNativePriceInUsdt() {
                const vm = this;
                try {
                    // 初始化 web3
                    if (!vm.web3) {
                        const provider = (typeof window !== 'undefined' && window.ethereum) || Web3.givenProvider;
                        if (!provider) {
                            console.warn('未检测到 Web3 提供者，无法获取价格与配对数量');
                            return;
                        }
                        vm.web3Provider = provider;
                        vm.web3 = new Web3(provider);
                    }

					// 最小化 Router ABI，仅使用 getAmountsOut
					const routerAbi = [{
						constant: true,
						inputs: [
							{ name: 'amountIn', type: 'uint256' },
							{ name: 'path', type: 'address[]' }
						],
						name: 'getAmountsOut',
						outputs: [ { name: 'amounts', type: 'uint256[]' } ],
						payable: false,
						stateMutability: 'view',
						type: 'function'
					}];

					const router = new vm.web3.eth.Contract(routerAbi, vm.ROUTER_ADDRESS);
                    const amountIn = vm.web3.utils.toWei('1', 'ether'); // 1 WROON（18 位精度）
                    const path = [vm.wroon_address, vm.usdr_address];
                    const amounts = await router.methods.getAmountsOut(amountIn, path).call();
                    const priceStr = vm.web3.utils.fromWei(amounts[1], 'ether');
                    vm.roon_usdr = vm.formatToFixedTrunc(priceStr, 6);

                    // 计算总价值 20 USDR 的等值配对数量
                    const totalUsdr = vm.totalUsdr; // 总价值 20 USDR
                    const halfUsdr = totalUsdr / 2; // 两侧等值
                    const price = parseFloat(priceStr); // 1 主币 = price USDR
                    if (!Number.isFinite(price) || price <= 0) {
                        console.warn('价格无效，无法计算配对数量');
                        vm.need_usdr = vm.formatToFixedTrunc(0, 6);
                        vm.need_roon = vm.formatToFixedTrunc(0, 6);
                        return;
                    }
                    const needUsdr = halfUsdr; // USDR 数量
                    const needRoon = halfUsdr / price; // 主币数量 = 半边USDR价值 / 单价
                    vm.need_usdr = vm.formatToFixedTrunc(String(needUsdr), 6);
                    vm.need_roon = vm.formatToFixedTrunc(String(needRoon), 6);

                    console.log('roon_usdr',vm.roon_usdr)
                    console.log('need_usdr',vm.need_usdr)
                    console.log('need_roon',vm.need_roon)
                } catch (err) {
                    console.error('获取主币/USDR 路由价格或配对数量失败：', err);
                }
            },
			// 获取链上主币余额与 USDR 余额，并分别赋值到 roon_blanace 与 usdr_blanace
			async fetchNativeAndUsdrBalance() {
				const vm = this;
				try {
					// 初始化 web3
					if (!vm.web3) {
						const provider = (typeof window !== 'undefined' && window.ethereum) || Web3.givenProvider;
						if (!provider) {
							console.warn('未检测到 Web3 提供者，无法获取余额');
							return;
						}
						vm.web3Provider = provider;
						vm.web3 = new Web3(provider);
					}

					// 获取地址（优先使用现有地址，否则尝试从钱包获取）
					let address = vm.address;
					if (!address) {
						try {
							if (vm.web3 && vm.web3.eth && vm.web3.eth.requestAccounts) {
								const accounts = await vm.web3.eth.requestAccounts();
								address = accounts && accounts[0] ? accounts[0] : '';
								vm.address = address;
							} else {
								const accounts = await vm.web3.eth.getAccounts();
								address = accounts && accounts[0] ? accounts[0] : '';
								vm.address = address;
							}
						} catch (e) {
							console.warn('获取钱包地址失败', e);
						}
					}

					if (!address) {
						console.warn('地址为空，无法获取余额');
						return;
					}

					// 获取主币余额（例如 BNB/ETH/ROON 等）
					const balanceWei = await vm.web3.eth.getBalance(address);
					const nativeBalance = vm.web3.utils.fromWei(balanceWei, 'ether');
					vm.roon_blanace = vm.formatToFixedTrunc(nativeBalance, 6);


					// 获取 USDR 余额（ERC20，USDR 小数位固定为 18）
					const usdrContract = new vm.web3.eth.Contract(erc20Abi, vm.usdr_address);
					const rawUsdrBalance = await usdrContract.methods.balanceOf(address).call();
					vm.usdr_blanace = vm.formatToFixedTrunc(vm.web3.utils.fromWei(rawUsdrBalance, 'ether'), 6);

                    console.log("vm.roon_blanace",vm.roon_blanace)
                    console.log("vm.usdr_blanace",vm.usdr_blanace)
				} catch (err) {
					console.error('获取主币/USDR 余额失败：', err);
				}
			},
			goToLock() {
				this.$router.push({
					path: '/lock'
				})
			},
			getList() {
				let vm = this
				getShowAddress()
				ajaxData("/rgt/swap").then(res => {
					console.log(res)
					vm.address = res.data.address;
					vm.rgt_swap = res.data.rgt_swap;
					vm.node_name = res.data.node_name;
					vm.total_address = res.data.total_address;
					vm.roon_number = res.data.roon_number;
					vm.all_surplus_roon = res.data.all_surplus_roon;

					// vm.getUserNodePurchaseStatus()
				})
			},
			async getUserNodePurchaseStatus() {
				const vm = this;
				const contract = new vm.web3.eth.Contract(Mining_Abi, vm.mining_contract);
				let data = await contract.methods.getUserNodePurchaseStatus(vm.address).call();
				console.log(data)
				console.log(data.nodeCount)
			},
			handleInputTwo() {
				const vm = this;
				let val = String(vm.form?.amount ?? '');
				// 仅保留数字（不允许小数点与其他字符）
				val = val.replace(/\D/g, '');
				// 解析后的数值可能出现 NaN 的情况，需回退
				const parsed = parseInt(val, 10);
				if (!val.length || Number.isNaN(parsed) || !Number.isFinite(parsed)) {
					vm.form.amount = '';
					vm.form.dd_roon = 0;
					return;
				}
				vm.form.amount = parsed;
				vm.form.dd_roon = parsed / 20;
			},
			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			selectAmount(number) {
				this.form.amount = parseInt(number);
				this.form.dd_roon = this.form.amount / 20;

				// this.form.amount_id = item.id;
				// this.showAmountPopup = false;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	.swap-item1-bg-image {
		width: 690rem;
		height: 240rem;
		background-image: url("~@/assets/images/pages/swap/img_banner.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.swap-item2-bg-image {
		width: 326rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/swap/item1Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.swap-item3-bg-image {
		width: 326rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/swap/item2Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.bg-\#5ACC3C {
		background-color: #5ACC3C;
	}
</style>



